import { Link, useLocation } from "react-router-dom";
import { useNotificationCount } from "../../Context/NotificationContext";
import NotificationBadge from "./NotificationBadge";
import "./header.scss";

// Same bell glyph geometry as the BottomNavigation notifications tab and
// the Notifications page cards (24px stroke language, round caps) so the
// Header entry matches the existing notification visuals.
export function HeaderNotificationIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  );
}

// Header notifications entry: links to /notifications and shows the REAL
// notification count (shared NotificationContext data — no hardcoded
// numbers, no duplicated API logic). Read-only: it never mutates
// notification state, it just reflects the shared store.
function HeaderNotification({
  to = "/notifications",
  label = "اعلان‌ها",
}) {
  const { count } = useNotificationCount();
  const { pathname } = useLocation();
  const active = pathname === to || pathname.startsWith(`${to}/`);
  const accessibleLabel =
    count > 0 ? `${label} (${count})` : label;

  return (
    <Link
      to={to}
      className={`HeaderNotification${active ? " HeaderNotification--active" : ""}`}
      aria-label={accessibleLabel}
      title={accessibleLabel}
      aria-current={active ? "page" : undefined}
      data-testid="header-notification"
      data-active={active ? "true" : "false"}
    >
      <span className="HeaderNotification-icon" aria-hidden="true">
        <HeaderNotificationIcon />
        <NotificationBadge count={count} />
      </span>
    </Link>
  );
}

export default HeaderNotification;
